import { render } from "./ModalQuiz.vue?vue&type=template&id=27363125&scoped=true&ts=true"
import script from "./ModalQuiz.vue?vue&type=script&lang=ts"
export * from "./ModalQuiz.vue?vue&type=script&lang=ts"

import "./ModalQuiz.vue?vue&type=style&index=0&id=27363125&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27363125"]])

export default __exports__